const angular = require('angular');
var app = angular.module('learn-controllers');
const moment = require('moment');

 /**
 * User Profile Display Controller
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Users} Users the resource defined to manage Users
 */

app.directive('userProfileDisplay', ['Application', 'Authorization', 'Users', 'MainComments', 'Analyze', '$translate', function (Application, Authorization, Users, MainComments, Analyze, $translate) {
  return {
    restrict: 'E',
    scope: {
      userId: '=',
      overlay: '@',
      onExit: '&'
    },
    template: require('../../templates/directives/user-profile-display.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var adminRoles = ['admin', 'creator'];
      var previousPage = Application.navigation.history.length - 2;
      self.user = {};
      self.visitingUser = Authorization.getAuthToken().user;
      self.isAdmin = adminRoles.indexOf(self.visitingUser.role) !== -1;
      self.routeParameters = Application.navigation.getRouteParameters();
      self.profileId = self.routeParameters.profileid || $scope.userId || null;
      self.companyName = Authorization.getAuthToken().company && Authorization.getAuthToken().company.name ? Authorization.getAuthToken().company.name : null;
      self.navigateAway = function() {
        if ($scope.overlay) {
          if ($scope.onExit) {
            $scope.onExit({});
          }
          return;
        }
        if (previousPage > 1) {
          Application.navigation.back(previousPage);
          return;
        }
        Application.navigation.goTo('/explore', {});
      };

      self.flags = Application.features.flags();

      self.getHiredDate = function(date) {

        var since = moment().diff(moment(date), 'months');
        var years = ~~(since/12);
        var months = since % 12;

        return(years ? (years > 1 ? years + ' Years ' : '1 Year ') : '') + (months > 1 ? months + ' Months' : ((!years || months === 1) ? '1 Month' : '' ));
      }

      self.edit =  {
        show: self.visitingUser._id === self.profileId,
        goTo: function() {
          Application.navigation.goTo('/dashboard/settings');
        }
      }

      self.initialize = function () {

        self.loading = true;
        Users.get({
          fields: 'first_name,last_name,full_name,email,image,role,linked_departments,linked_locations,skills,job_title,hired,social_links,about,banner_image,department,office_location',
          subresource: self.profileId + '',
          'skills-populate': 'name',
          'linked_locations-populate': 'name',
          'linked_departments-populate': 'name'
        }, function (data) {
          self.user = data;
          self.user.hiredOn = (!self.user.hired || self.user.hired  + '' == '1970-01-01T00:00:00.000Z') ? undefined : self.getHiredDate(self.user.hired);
          self.user.banner_image = Application.imageCdn.baseUrl + Application.imageCdn.sharedProps + ',' + 'q_auto:eco' + '/' + (data.banner_image ? data.banner_image : 'https://d2277n3gvptnup.cloudfront.net/images/51d5f21b2f410a020b000002/cb4e0e69-b263-43a6-aa1d-f73d8325688c.jpg');
          self.loading = false;
        }, function (error) {
          console.log('Error occured getting user profile ', error);
        });

        MainComments.count({
          user: self.profileId + ''
        }, function (data) {
            self.comments_count = data.count;
        }, function (err) {
            console.log('error setting comment count: ', err);
          }
        );

        Analyze.viewCount({user: self.profileId, 'created_on': '$gte,date-' + moment().subtract(30, 'days').format('MM-DD-YY'), fields: 'user,created_on'}).$promise
        .then(function(data) {
          self.views_count = data.count;
        }).catch(function(error) {
          console.log('error: ', error);
        });
      };

      $translate(['modules.notifications.unableToGetUserTracks']).then(function(translations){
        self.translations = translations;
      });

      if ($scope.overlay) {
        $scope.$watch('userId', function(newVal, oldVal) {
          if (!newVal || newVal === oldVal) {
            return;
          }
          self.profileId = $scope.userId;
          self.initialize();
        });
        if (self.profileId) {
          self.initialize();
        }

      } else {
        self.initialize();
      }
    }],
    controllerAs: 'profile'
  }
}]);
